import debounce from "lodash/debounce";
import { isInfiniteScrollDown } from "logview/helpers";
import { LOADING_ROW_HEIGHT } from "./LogViewTable";
const ON_BORDER_REACH_DEBOUNCE_WAIT = 500;
const ON_BORDER_REACH_DEBOUNCE_OPTIONS = { leading: true, trailing: false };
const _thresholds = (tableScrollHeight, tableClientHeight, infiniteScrollDirection) => {
  const bottomThreshold = Math.round((tableScrollHeight - tableClientHeight) / 5);
  const topThreshold = LOADING_ROW_HEIGHT;
  if (isInfiniteScrollDown(infiniteScrollDirection)) {
    return {
      bottomThreshold: topThreshold,
      topThreshold: bottomThreshold
    };
  }
  return {
    bottomThreshold,
    topThreshold
  };
};
const debouncedOnBottomReach = debounce(
  (onBottomReach) => {
    onBottomReach();
  },
  ON_BORDER_REACH_DEBOUNCE_WAIT,
  ON_BORDER_REACH_DEBOUNCE_OPTIONS
);
const debouncedOnTopReach = debounce(
  (onTopReach) => {
    onTopReach();
  },
  ON_BORDER_REACH_DEBOUNCE_WAIT,
  ON_BORDER_REACH_DEBOUNCE_OPTIONS
);
const _onTopOrBottomReach = debounce(
  ({
    bottomThreshold,
    onBottomReach,
    onTopReach,
    tableClientHeight,
    tableScrollHeight,
    tableScrollTop,
    topThreshold
  }) => {
    if (tableScrollTop <= topThreshold) {
      debouncedOnTopReach(onTopReach);
    }
    if (tableScrollHeight - tableScrollTop - tableClientHeight <= bottomThreshold) {
      debouncedOnBottomReach(onBottomReach);
    }
  },
  100
);
const onScroll = ({
  onBottomReach,
  onTopReach,
  tableRef,
  infiniteScrollDirection,
  finishedScrollPositionUpdateRef,
  loadPrevPromiseRef
}) => {
  const tableScrollTop = tableRef.current.scrollTop;
  const tableScrollHeight = tableRef.current.scrollHeight;
  const tableClientHeight = tableRef.current.clientHeight;
  const { bottomThreshold, topThreshold } = _thresholds(tableScrollHeight, tableClientHeight, infiniteScrollDirection);
  if (finishedScrollPositionUpdateRef.current && !(loadPrevPromiseRef == null ? void 0 : loadPrevPromiseRef.current)) {
    _onTopOrBottomReach({
      bottomThreshold,
      onBottomReach,
      onTopReach,
      tableClientHeight,
      tableScrollHeight,
      tableScrollTop,
      topThreshold
    });
  }
};
export default onScroll;
